const PinLocation02Icon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "7", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11L12 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 19C17 20.1046 14.7614 21 12 21C9.23858 21 7 20.1046 7 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export { PinLocation02Icon as default };
//# sourceMappingURL=PinLocation02Icon.js.map
